<template>
  <div class="infoTilesSection">
    <div class="container">
      <IconBoxes :items="items" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import IconBoxes from '@/components/IconBoxes.vue';

export default {
  name: 'LandingHeaderSection',
  components: { IconBoxes },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState({
      businessVariables: state => state.settings.businessVariables,
    }),
    items() {
      return this.data.Tiles.map(({ Icon, IconAlt, Url, Title, Description }) => ({
        href: Url,
        alt: IconAlt,
        title: Title,
        desc: this.parseDescription(Description),
        icon: Icon ? JSON.parse(Icon).url : '',
        width: 60,
        height: 38,
      }));
    },
  },
  methods: {
    parseDescription(desc) {
      if (desc.includes('$freeShipping')) {
        return desc.replace('$freeShipping', this.businessVariables.freeShipping.grossFormatted);
      }
      return desc;
    },
  },
};
</script>

<style scoped lang="scss">
.infoTilesSection {
  margin-bottom: 1.6rem;
}
</style>
